const NUMBER = /(?<![\w@.*£$€-])([£$€]?\d(?:[\d,]*\d)?(?:\.\d+)?(?:[kKmMbB](?![a-zA-Z]))?%?)(?![\w*])/g;

const UNBOLDED = new RegExp(
  `(${[
    /\*\*[^*]+\*\*/,
    /`[^`]+`/,
    /\[[^\]]*\]\([^)]*\)/,
    /https?:\/\/\S+/,
    /\b\d{4}-\d{2}(?:-\d{2})?\b/,
    /\b\d{1,2}\/\d{1,2}\/\d{2,4}\b/,
    /\b\d{6,}\b/,
    /^[ \t]*\d+[.)](?=[ \t])/,
  ]
    .map((part) => part.source)
    .join("|")})`,
  "m",
);

/** Marks standalone figures as bold Markdown, leaving bold, code, links, dates, list markers and ids as they are. */
export function boldNumbers(text: string): string {
  return text
    .split(UNBOLDED)
    .map((part, i) => (i % 2 === 1 ? part : part.replace(NUMBER, "**$1**")))
    .join("");
}

const LABEL_PREFIX = /^([A-Z][A-Z\s/-]{2,})(?::\s*|\s+—\s*)([\s\S]+)/;

/** A short label for a finding: the model's "ALL CAPS LABEL: text" prefix, or "Finding". */
export function findingLabel(finding: string): { label: string; text: string } {
  const prefixed = finding.match(LABEL_PREFIX);
  if (prefixed) {
    const label = prefixed[1].trim().toLowerCase();
    return { label: label.charAt(0).toUpperCase() + label.slice(1), text: prefixed[2] };
  }
  return { label: "Finding", text: finding };
}
